import React, { Component } from 'react';
import {NavLink, Link} from "react-router-dom";
import logo from '../Assets/logo.png';
import {name, year} from "../Constant";
import Footer from "../Components/footer";
import { getState, UpdateState } from '../Components/function';

  class PayPalCancel extends Component{

    constructor(props){
      super(props);
      
      this.state = {
        message: '',
        transactionID: 'N/A',
        inline: 0,
      }
      }

      componentDidMount(){
        const query = new URLSearchParams(this.props.location.search);
        const token = query?.get('token');
        const inline = query?.get('inline');
        if(token && token != false && token != undefined && token != null){
        UpdateState(this, 'transactionID', token);
        }
        if(inline && inline != false && inline != undefined && inline != null){
          UpdateState(this, 'inline', inline);
          }
      }
      
      render(){
    return (
        <div className="App">
      <div className="body-wrapper" id="body-wrapper">
      <div className="form-first-child"> </div>

        <div className="form-wrapper">
      <div className="form-wrap">
        <div className="logo-wrap">
          <div className="logo-inner-wrap">
          <NavLink to="/">
            <img className="logo" src={logo} title={name + " Logo"} alt={name + " Logo"}/>
            </NavLink>
          </div>
          </div>
      <div className="form-inner-wrap">
       <h1><span className="text404" style={{color: 'red', }}><i className="fa fa-times-circle"></i></span><br/>
        <small className="text404small">PayPal Payment with ID <font color="red">#{getState(this, 'transactionID')}</font> was cancelled successfully.</small> </h1>
        <div className="form-group-lg">
         <NavLink to="/dashboard">
       <button className="btn btn-blue btn-link">GO TO DASHBOARD</button>
       </NavLink>
       </div> 
       <div className="form-group-lg" hidden={(getState(this, 'inline') != '1')}>

       <button className="btn btn-pink btn-link hidden" onClick={(input) => window.close()}>CLOSE WINDOW</button>
          
         </div> 
         </div>
        </div>
      </div>
      </div>

      <Footer/>
    </div>
    );
    }
}

export default PayPalCancel;